<template>
    <div :class="['hero', isLogged]" :style="cssVars">
        <component :is="getHeroComponent" :key="currentLanguage" />
    </div>
</template>

<script>

    import HeroLogged from 'components/landingpage/hero/HeroLogged'
    import HeroNonLogged from 'components/landingpage/hero/HeroNonLogged'
    import HeroLoggedGoLearn from 'components/landingpage/hero/HeroLoggedGoLearn'
    import HeroLoggedEduhouseFI from 'components/landingpage/hero/HeroLoggedEduhouseFI'
    import HeroLoggedEduhouseSE from 'components/landingpage/hero/HeroLoggedEduhouseSE'
    import HeroLoggedEduhouseNO from 'components/landingpage/hero/HeroLoggedEduhouseNO'
    import { mapGetters } from 'vuex'
    import { heroDataHelper } from 'components/landingpage/hero/heroDataHelper'

    export default {
        name: 'hero',
        components: { HeroLogged, HeroNonLogged, HeroLoggedGoLearn, HeroLoggedEduhouseFI, HeroLoggedEduhouseSE, HeroLoggedEduhouseNO },
        mixins: [heroDataHelper],
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                isReportingAllowed: 'User/getIsReportingAllowed',
                currentLanguage: 'Languages/getSelectedCountryCode',
                notificationHeight: 'getNotificationHeight'
            }),
            isLogged () {
                if (this.isLoggedIn) {
                    return 'logged'
                } else {
                    return 'non-logged'
                }
            },
            getHeroComponent () {
                if (this.isLoggedIn) {
                    if (this.$totemLang === 'dk') {
                        return 'HeroLoggedGoLearn'
                    }
                    if (this.$totemLang === 'fi' && this.isLoggedIn) {
                        return 'HeroLoggedEduhouseFI'
                    }
                    if (this.$totemLang === 'se') {
                        return 'HeroLoggedEduhouseSE'
                    }
                    if (this.$totemLang === 'no') {
                        return 'HeroLoggedEduhouseNO'
                    }
                    return 'HeroLogged'
                }
                return 'HeroNonLogged'
            },
            cssVars () {
                if (this.notificationHeight !== 0) {
                    return {
                        '--top': this.notificationHeight + 'px',
                        '--margin-bottom': this.notificationHeight + 'px'
                    }
                }

                return {
                    '--top': '-80px',
                    '--margin-bottom': '-80px'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.hero {
    background: $light_blue;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;

    [class*="desktop"] & {
        position: relative;
        padding: 80px 0 0 0;
        height: 506px;
        top: var(--top);
        margin-bottom: var(--margin-bottom);
    }
}
</style>
